import WPStagingCommon from '../../wpstg.js';
import 'regenerator-runtime/runtime';
import WPStagingBackup from './wpstg-backup';
import wpstgAuthCheck from './wpstg-auth-check';
import * as dom from './../../modules/wpstg-dom-utils';

let WPStagingBackupCreate;

(function($) {
  window.addEventListener('backups-tab', function() {
    WPStagingBackupCreate.listen();
  });

  window.addEventListener('startedCreatingBackup', function() {
    window.addEventListener('beforeunload', WPStaging.warnIfClosingDuringProcess);
  });

  WPStagingBackupCreate = {
    listen() {
      $('body')
          .off('click', '#wpstg-new-backup', WPStagingBackupCreate.clickedBackup)
          .on('click', '#wpstg-new-backup', WPStagingBackupCreate.clickedBackup)
          .off('change', '.wpstg--swal2-container .wpstg-advanced-options-site input[type=checkbox]')
          .on('change', '.wpstg--swal2-container .wpstg-advanced-options-site input[type=checkbox]', WPStagingBackupCreate.warnBackupMediaWithoutDatabase)
          .off('change', '[type="checkbox"][name="includedDirectories\[\]"], input#includeDatabaseInBackup, input#includeOtherFilesInWpContent, [type="checkbox"][name="storages"]')
          .on('change', '[type="checkbox"][name="includedDirectories\[\]"], input#includeDatabaseInBackup, input#includeOtherFilesInWpContent, [type="checkbox"][name="storages"]', WPStagingBackupCreate.disableBackupButtonIfNoSelection)
          .on('click', '#wpstg-copy-backup-url', dom.copyTextToClipboard)
      ;
    },
    async clickedBackup(e) {
      WPStagingCommon.resetErrors();
      e.preventDefault();
      WPStagingBackup.isCancelled = false;

      if (!WPStagingBackup.modal.create.html || !WPStagingBackup.modal.create.confirmBtnTxt) {
        const $newBackupModal = $('#wpstg--modal--backup--new');
        const html = $newBackupModal.html();
        const btnTxt = $newBackupModal.attr('data-confirmButtonText');
        WPStagingBackup.modal.create.html = html || null;
        WPStagingBackup.modal.create.confirmBtnTxt = btnTxt || null;
        $newBackupModal.remove();
      }

      const {value: formValues} = await WPStagingCommon.getSwalModal(false, {
        confirmButton: 'wpstg--btn--confirm wpstg-blue-primary wpstg-button wpstg-link-btn',
      }).fire({
        title: '',
        html: WPStagingBackup.modal.create.html,
        focusConfirm: false,
        confirmButtonText: WPStagingBackup.modal.create.confirmBtnTxt,
        showCancelButton: true,
        preConfirm: () => {
          const container = WPStagingCommon.getSwalContainer();
          WPStagingBackup.modal.create.hasBackupSchedule = WPStagingBackup.modal.create.hasBackupSchedule ? true : !container.querySelector('#repeatBackupOnSchedule').checked;
          WPStagingBackup.processInfo.isOnlySchedule = !container.querySelector('#repeatBackupOnSchedule').checked && (!container.querySelector('#backupScheduleLaunch').checked);

          const selectedStorages = container.querySelectorAll('input[name="storages"]:checked');
          const storages = [];
          for (const storage of selectedStorages) {
            storages.push(storage.value);
          }

          WPStagingCommon.selectedStorages = storages;

          return {
            name: WPStagingCommon.sanitizeEventAttribute(container.querySelector('input[name="backup_name"]').value) || null,
            isExportingPlugins: container.querySelector('#includePluginsInBackup:checked') !== null,
            isExportingMuPlugins: container.querySelector('#includeMuPluginsInBackup:checked') !== null,
            isExportingThemes: container.querySelector('#includeThemesInBackup:checked') !== null,
            isExportingUploads: container.querySelector('#includeMediaLibraryInBackup:checked') !== null,
            isExportingOtherWpContentFiles: container.querySelector('#includeOtherFilesInWpContent:checked') !== null,
            isExportingDatabase: container.querySelector('#includeDatabaseInBackup:checked') !== null,
            repeatBackupOnSchedule: container.querySelector('#repeatBackupOnSchedule:not(:checked)') !== null,
            scheduleRecurrence: container.querySelector('#backupScheduleRecurrence').value || null,
            scheduleTime: container.querySelector('#backupScheduleTime').value || null,
            scheduleRotation: container.querySelector('#backupScheduleRotation').value || null,
            storages: storages,
            isCreateScheduleBackupNow: container.querySelector('#backupScheduleLaunch:checked') !== null,
            backupType: container.querySelector('[name="backupType"]').value || null,
            isSmartExclusion: container.querySelector('#wpstgSmartExclusion:checked') !== null,
            isExcludingSpamComments: container.querySelector('#wpstgExcludeSpamComments:checked') !== null,
            isExcludingPostRevision: container.querySelector('#wpstgExcludePostRevision:checked') !== null,
            isExcludingDeactivatedPlugins: container.querySelector('#wpstgExcludeDeactivatedPlugins:checked') !== null,
            isExcludingUnusedThemes: container.querySelector('#wpstgExcludeUnusedThemes:checked') !== null,
            isExcludingLogs: container.querySelector('#wpstgExcludeLogs:checked') !== null,
            isExcludingCaches: container.querySelector('#wpstgExcludeCaches:checked') !== null,
          };
        },
        onRender() {
          if (WPStagingBackup.modal.create.hasBackupSchedule === true) {
            document.querySelectorAll('#repeatBackupOnSchedule.wpstg-is-basic').forEach((el) => {
              el.disabled = true;
            });

            document.querySelectorAll('.wpstg-basic-schedule-notice.wpstg-is-basic').forEach((el) => {
              el.style.display = 'block';
            });
          }

          if (WPStagingBackup.modal.create.hasBackupSchedule === false) {
            document.querySelectorAll('#repeatBackupOnSchedule.wpstg-is-basic').forEach((el) => {
              el.disabled = false;
            });

            document.querySelectorAll('.wpstg-basic-schedule-notice.wpstg-is-basic').forEach((el) => {
              el.style.display = 'none';
            });
          }
        },
      });

      if (!formValues) {
        return;
      }

      WPStagingBackup.process({
        execute: () => {
          WPStagingBackup.messages.reset();
          WPStagingBackupCreate.prepareBackup(formValues);
        },
      });
    },
    prepareBackup(data) {
      WPStagingCommon.ajax(
          {
            action: 'wpstg--backups--prepare-backup',
            accessToken: wpstg.accessToken,
            nonce: wpstg.nonce,
            wpstgBackupData: data,
          },
          function(response) {
            if (response.success) {
              window.dispatchEvent(new Event('startedCreatingBackup'));
              WPStagingBackup.timer.start();
              wpstgAuthCheck.status = true;
              wpstgAuthCheck.start();
              WPStagingBackupCreate.createBackup();
            } else {
              WPStagingCommon.showAjaxFatalError(response.data, '', 'Submit an error report.');
            }
          },
          'json',
          false,
          10,
          1.25,
          function(xhr, textStatus, errorThrown) {
            if (xhr.status === 423) {
              WPStagingCommon.continueErrorHandle = false;
              WPStagingBackup.shouldCleanUp = false;
              WPStagingCommon.closeSwalModal();

              setTimeout(function() {
                WPStagingBackup.shouldCleanUp = true;
              }, 1000);

              WPStagingCommon.showErrorModal(xhr.responseJSON.data);
            } else {
              WPStagingCommon.continueErrorHandle = true;
            }
          },
      );
    },
    createBackup() {
      const maxBackupSequentialReturnError = wpstg.maxFailedRetries;
      let backupReturnedError = 0;
      WPStagingCommon.resetErrors();

      if (WPStagingBackup.isCancelled) {
        WPStagingBackup.statusStop();
        return;
      }
      WPStagingCommon.ajax(
          {
            action: 'wpstg--backups--create',
            accessToken: wpstg.accessToken,
            nonce: wpstg.nonce,
          },
          async function(response) {
            backupReturnedError = 0;

            if (WPStagingBackup.isCancelled) {
              return;
            }

            if (typeof response === 'undefined') {
              setTimeout(function() {
                WPStagingBackupCreate.createBackup();
              }, wpstg.delayReq);
              return;
            }

            WPStagingBackup.processResponse(response);
            if (!WPStagingBackup.processInfo.interval) {
              WPStagingBackup.statusStart('create');
            }

            if (response.isRunning === true) {
              WPStagingBackupCreate.createBackup();
            } else if (response.jobStatus === 'JOB_FAIL') {
              await WPStagingBackup.checkMemoryExhaustion(response, 'wpstg_backup');
              setTimeout(function() {
                WPStagingBackupCreate.createBackup();
              }, wpstg.delayReq);
            } else {
              $('#wpstg--progress--status').text('Backup successfully created!');
              wpstgAuthCheck.stop();
              dom.setLoadingPlaceholder().then(() => dom.loadingPlaceholder());
              if (WPStagingBackup.messages.shouldWarn()) {
              // noinspection JSIgnoredPromiseFromCall
                WPStagingBackup.fetchListing();
                WPStagingBackup.logsModal();
                return;
              }

              WPStagingBackup.statusStop();
              WPStagingCommon.closeSwalModal();
              WPStagingBackup.fetchListing()
                  .then(() => {
                    if (!response.backupMd5 && !WPStagingBackup.processInfo.isOnlySchedule) {
                      WPStagingCommon.showError('<strong>Warning</strong>: Failed to get backup md5 from response!<br/>Response content: '+JSON.stringify(response)+'<br/><br/>Please report this warning <a href="https://wp-staging.com/support/" target="_blank">to our support</a> and keep using WP Staging!');
                      return;
                    }

                    // load remote backups list only when remote storage is selected.
                    if (Array.isArray(WPStagingCommon.selectedStorages) &&
                    ((WPStagingCommon.selectedStorages.includes('localStorage') && WPStagingCommon.selectedStorages.length >= 2) ||
                    (!WPStagingCommon.selectedStorages.includes('localStorage') && WPStagingCommon.selectedStorages.length >= 1))
                    ) {
                      $('#wpstg-show-cloud-backup').click();
                    }

                    // Wait for fetchListing to populate the DOM with the backup data that we want to read
                    let $el = '';
                    let timesWaited = 0;
                    const intervalWaitForBackupInDom = setInterval(function() {
                      if (!WPStagingBackup.processInfo.isOnlySchedule && response.isLocalBackup) {
                        timesWaited++;

                        let backupFound = false;
                        if (!response.isMultipartBackup) {
                          $el = $(`.wpstg-backup[data-md5="${response.backupMd5}"] .wpstg--backup--download`);
                          backupFound = $el.length > 0;
                        } else {
                          response.backupMd5.forEach((md5) => {
                            $el = $(`.wpstg-backup[data-md5="${md5}"] .wpstg--backup--download`);
                            if ($el.length) {
                              backupFound = true;
                            }
                          });
                        }

                        // Could not find element, let's try again...
                        if (!backupFound) {
                          if (timesWaited >= 20) {
                            // Bail: We tried too many times and couldn't find.
                            clearInterval(intervalWaitForBackupInDom);
                          }
                          return;
                        }

                        // Found it. No more need for the interval.
                        clearInterval(intervalWaitForBackupInDom);
                      } else {
                        // Just clear the interval
                        clearInterval(intervalWaitForBackupInDom);
                      }

                      WPStagingBackup.downloadModal({
                        title: WPStagingBackup.processInfo.isOnlySchedule ? 'Backup Schedule Created' : 'Backup Complete',
                        bodyText: WPStagingBackup.processInfo.isOnlySchedule ? 'Backup is scheduled according to the provided settings.' : null,
                      });
                      $('.wpstg-backup-success-logs-wrapper').show();
                      const $logsContainer = $('.wpstg-backup-success-logs');
                      WPStagingBackup.messages.data.all.forEach((message) => {
                        const msgClass = `wpstg--modal--process--msg--${message.type.toLowerCase()}`;
                        $logsContainer
                            .append(`<p class="${msgClass}">[${message.type}] - [${message.date}] - ${message.message}</p>`)
                        ;
                      });
                    }, 500);
                  })
              ;
            }
          },
          'json',
          false,
          0, // Don't retry upon failure
          1.25,
          function(xhr, textStatus, errorThrown) {
            WPStagingCommon.continueErrorHandle = false;
            const response = {
              'messages': [],
            };

            backupReturnedError++;

            // Prevents loop in case PHP crashes constantly before being able to respond
            if (backupReturnedError <= maxBackupSequentialReturnError) {
              WPStagingBackupCreate.createBackup();
            } else {
              response.messages.push({
                'type': 'critical',
                'message': 'There was a PHP fatal error while processing the backup. You might need to check your PHP error log to find out the reason. Please contact WP STAGING support if you need help.',
              });

              WPStagingBackup.processResponse(response);
              WPStagingBackup.cancel();
              setTimeout(WPStagingBackup.logsModal, 500);
            }
          },
      );
    },
    warnBackupMediaWithoutDatabase(event) {
      const container = event.currentTarget.closest('.wpstg--swal2-container');
      event.preventDefault();
      // this is for remote upload feature PR: 2611
      if (container.querySelector('#includeDatabaseInBackup') === null && container.querySelector('#includeMediaLibraryInBackup') === null) {
        return;
      }

      const isExportingDatabase = container.querySelector('#includeDatabaseInBackup').checked;
      const isExportingMediaLibrary = container.querySelector('#includeMediaLibraryInBackup').checked;

      if (isExportingMediaLibrary && !isExportingDatabase) {
        container.querySelector('#backupUploadsWithoutDatabaseWarning').style.display = 'block';
      } else {
        container.querySelector('#backupUploadsWithoutDatabaseWarning').style.display = 'none';
      }
    },
    disableBackupButtonIfNoSelection(event) {
      const container = event.currentTarget.closest('.wpstg--swal2-container');
      event.preventDefault();
      const checkboxesStorages = Array.from(container.querySelectorAll('[type="checkbox"][name="storages"]:checked'));
      const isStorageSelected = checkboxesStorages.length > 0;
      // this is for remote upload feature
      if (container.querySelector('#includeDatabaseInBackup') === null && container.querySelector('#includeMediaLibraryInBackup') === null) {
        container.querySelector('.wpstg--swal2-confirm').disabled = !isStorageSelected;
        return;
      }

      const checkboxesDirs = Array.from(container.querySelectorAll('[type="checkbox"][name="includedDirectories[]"]:checked'));
      const isExportingAnyDir = checkboxesDirs.length > 0;

      const checkboxesDatabase = Array.from(container.querySelectorAll('input#includeDatabaseInBackup:checked'));
      const isExportingDatabase = checkboxesDatabase.length === 1;

      const checkboxesOtherFiles = Array.from(container.querySelectorAll('input#includeOtherFilesInWpContent:checked'));
      const isExportingOtherFilesInWpContent = checkboxesOtherFiles.length === 1;


      const confirmButton = container.querySelector('.wpstg--swal2-confirm');
      confirmButton.disabled = !isExportingAnyDir && !isExportingDatabase && !isExportingOtherFilesInWpContent || !isStorageSelected;
    },
  };
}(jQuery));

export default WPStagingBackupCreate;
